var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModuleDashboard = function SvgModuleDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.979 13.128 4.68-5.958 5.107 4.256 6.383-8.724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1v16.596h20"
  }))));
};
export default SvgModuleDashboard;